// 開いているモーダルのスタック。ショートカットの無効化判定に使う
// (DOM のクラス名を querySelector する方式より確実)。
import { ref, computed, onBeforeUnmount } from 'vue'

const stack = ref<string[]>([])

export function pushModal(id: string): void {
  if (!stack.value.includes(id)) stack.value.push(id)
}

export function popModal(id: string): void {
  stack.value = stack.value.filter(x => x !== id)
}

export const isModalOpen = computed(() => stack.value.length > 0)

/** コンポーネントの表示中だけモーダルとして登録する */
export function useModal(id: string) {
  pushModal(id)
  onBeforeUnmount(() => popModal(id))
}
